import Container from 'components/Container';
import SectionTitle from 'components/SectionTitle';
import TextWithBackground from 'components/TextWithBackground';
import Magnetic from 'components/Magnetic';
import MouseTracker from 'components/MouseTracker';
import s from './style.css';
import cn from 'classnames';

const colors = [
	{
		leftColor: '#9ce4c9',
		rightColor: '#fff'
	},
	{
		leftColor: '#fff',
		rightColor: '#cdf1e4'
	},
	{
		leftColor: '#fff',
		rightColor: '#b7e5de'
	},
	{
		leftColor: '#fff',
		rightColor: '#b9dce9'
	},
	{
		leftColor: '#fff',
		rightColor: '#9bbbf2'
	},
	{
		leftColor: '#9dbcf1',
		rightColor: '#fff'
	}
];

const Chapter = ({
	children,
	title,
	standFirst,
	highlight = [],
	onRight,
	section = 0
}) => (
	<div
		className={cn(s.wrap, {
			[s.onRight]: onRight,
			[s[`section${section}`]]: section
		})}
	>
		<Container>
			{section !== 1 &&
				section !== 5 && (
				<MouseTracker
					className={cn(s.magnetic, { [s.magnetCenter]: section === 0 })}
					render={mouse => (
						<Magnetic
							{...mouse}
							rows={section === 0 ? 15 : 7}
							{...colors[section]}
						/>
					)}
				/>
			)}

			{title && <SectionTitle title={title} />}
			{standFirst && (
				<TextWithBackground
					highlight={highlight}
					highlightColors={['yellow']}
					tag="h3"
					className={s.standfirst}
				>
					{standFirst}
				</TextWithBackground>
			)}
			{children}
		</Container>
	</div>
);

export default Chapter;



// WEBPACK FOOTER //
// ./components/Chapter/index.js